
const Layout = ({ children }) => (
    <main className="flex-grow p-8">
        {children}
    </main>
)

export default Layout
